<template>
    <div class='info-edit-modal'>
        <b-modal :active="true" :canCancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Rediger studerende: {{student.name}}</p>
                </header>

                <section class="modal-card-body">
                    <b-field :label="$t('global.forms.student.name')"
                             :type="{'is-danger': veeErrors.has('name')}"
                             :message="veeErrors.first('name')">
                        <b-input v-model="editableStudent.name" name="name"
                                 v-validate="'required'" :data-vv-as="$t('global.forms.name')" />
                    </b-field>

                    <template v-if="editableStudent.name !== student.name">
                        <small class="has-text-danger">
                            Bemærk at ændringer af navnet ændrer linket til den studerendes profil
                        </small>
                        <br>
                        <br>
                    </template>

                    <h3 class="subtitle is-4">Notater</h3>
                    <div class="columns">
                        <div class="column">
                            <b-field :label="$t('global.forms.Notes')">
                                <b-input type="textarea" cols="50" rows="10" v-model="editableStudent.notes" name="notes"
                                         :data-vv-as="$t('global.forms.notes')" />
                            </b-field>
                        </div>
                    </div>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="close" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any()">{{$t('global.actions.update')}}</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import StudentService from '@/taskflex/students/services/StudentService';

    export default {
        data() {
            return {
                editableStudent: null,
                isSubmitting: false,
            };
        },

        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            this.editableStudent = Object.assign({}, this.student);
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const student = this.editableStudent;

                const options = {
                    name: student.name,
                    notes: student.notes,
                };

                this.isSubmitting = true;

                StudentService.update(this.student.id, options, ({ data }) => {
                    this.isSubmitting = false;

                    // Set the returned values that we updated, as well as the slug.
                    student.name = data.name;
                    student.slug = data.slug;

                    this.$emit('updated', student);
                    this.close();
                });
            },

            close() {
                this.$emit('close');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/students/InfoEditModal.vue